export default "__VITE_ASSET__cLD309D4__";